import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { css } from '@emotion/react';
import { useEffect } from 'react';
import { createInitMttStagingOutbound } from '../../api/outbound/mttStagingOutbounds';
import { MessageBoxesContainer } from '../../components/messageBoxes/messageBoxesContainer';
import { PrizeWinContainer } from '../../components/prizes/prizeWinContainer';
import { RebuyWindowContainer } from '../../components/rebuyWindowContainer';
import { ToastsContainer } from '../../components/toastsContainer';
import { useSocketSend } from '../../context/webSocket/webSocketContext';
import { useSceneResize } from '../../hooks/useSceneResize';
import { DEFAULT_BACKGROUND_COLOR } from '../../styles/colors';
import { MttStagingHeaderBar } from './mttStagingHeaderBar';
import { MttStagingSceneMainDisplay } from './mttStagingSceneMainDisplay';
const CONTAINER_CSS = css `
  display: flex;
  width: 100%;
  height: 100%;
  flex-direction: column;
  background-color: ${DEFAULT_BACKGROUND_COLOR};
`;
export const MttStagingScene = () => {
    const socketSend = useSocketSend();
    useEffect(() => {
        socketSend(createInitMttStagingOutbound());
    }, [socketSend]);
    useSceneResize();
    return (_jsxs("div", { "data-testid": 'mtt-staging-scene', css: CONTAINER_CSS, children: [_jsx(MttStagingHeaderBar, {}), _jsx(MttStagingSceneMainDisplay, {}), _jsx(ToastsContainer, {}), _jsx(MessageBoxesContainer, {}), _jsx(RebuyWindowContainer, {}), _jsx(PrizeWinContainer, {})] }));
};
